import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { serializeSortItem } from '@utils/utils';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-users/')({
  validateSearch: zodValidator(withDefaults(schema.USER_MANAGEMENT, { orderBy: [serializeSortItem({ property: 'email', isAsc: true })] })),
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermission },
    } = context;
    const path = PAGE_PATHS.ALL_USERS;
    const isAllowed = hasAllowedPermission({ path }) || hasAllowedPermission({ path, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
